import {
  PageWithHeader,
  SupportButton,
  useSupportConfig,
  TabbedLayout,
} from '@backstage/core-components';
import { Text } from '@backstage/ui';
import { CatalogContent } from './CatalogContent';
import { FrontendDependencyGraph, GemDependencyGraph } from './graphs';
import { DomainExplorerContent } from '@backstage-community/plugin-explore';

export const CatalogPage = () => {
  const { items: supportItems } = useSupportConfig();
  return (
    <PageWithHeader title="Catalog" themeId="home">
      <TabbedLayout>
        <TabbedLayout.Route path="" title="Catalog">
          <CatalogContent
            SupportButton={
              <SupportButton
                items={[
                  {
                    title: 'Getting started',
                    icon: 'docs',
                    links: [
                      {
                        url: '/help/explanations/catalog/',
                        title: 'How do I use this?',
                      },
                      {
                        url: '/help/references/catalog_relationships/',
                        title: 'What are catalog entities?',
                      },
                      {
                        url: '/help/contributors/#updating-the-catalog',
                        title: 'How do I add or change things?',
                      },
                      {
                        url: '/help/contributors/how_tos/update_ownership/',
                        title: 'How do I change ownership?',
                      },
                    ],
                  },
                  ...supportItems,
                ]}
              >
                <Text variant="body-medium">
                  The catalog lists and visualizes relationships between
                  software components, systems, APIs, resources, domains, and
                  teams.
                </Text>
              </SupportButton>
            }
          />
        </TabbedLayout.Route>
        <TabbedLayout.Route path="domains" title="Domains">
          <DomainExplorerContent />
        </TabbedLayout.Route>
        <TabbedLayout.Route path="gem-dependencies" title="Gem Dependencies">
          <GemDependencyGraph />
        </TabbedLayout.Route>
        <TabbedLayout.Route
          path="frontend-dependencies"
          title="Front-end Dependencies"
        >
          <FrontendDependencyGraph />
        </TabbedLayout.Route>
      </TabbedLayout>
    </PageWithHeader>
  );
};
